/**
 * Табы категорий кейсов.
 *
 * Счётчики считаются здесь, а не приходят с бэкенда: список кейсов у страницы
 * уже есть, лишний запрос ради шести чисел не нужен.
 *
 * Пустые категории скрываются — таб, который ведёт в пустую сетку, выглядит
 * как поломка. «Все» остаётся всегда: это состояние по умолчанию.
 */
const ICONS = {
  all: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="cat-tab-icon">
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
    </svg>
  ),
  budget: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="cat-tab-icon">
      <circle cx="12" cy="12" r="9" />
      <path d="M14.5 9h-4a1.5 1.5 0 0 0 0 3h3a1.5 1.5 0 0 1 0 3h-4" />
      <path d="M12 7v10" />
    </svg>
  ),
  themed: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="cat-tab-icon">
      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />
    </svg>
  ),
  premium: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="cat-tab-icon">
      <path d="M6 3h12l4 6-10 12L2 9l4-6z" />
      <path d="M11 3L8 9l4 12 4-12-3-6" />
      <path d="M2 9h20" />
    </svg>
  ),
}

export default function CategoryTabs({ categories, cases, value, onChange }) {
  if (!categories.length) return null

  const tabs = categories
    .map((cat) => ({
      ...cat,
      count:
        cat.id === 'all' ? cases.length : cases.filter((item) => item.category === cat.id).length,
    }))
    .filter((cat) => cat.id === 'all' || cat.count > 0)

  return (
    <div className="cat-tabs-container">
      <div className="cat-tabs" role="tablist" aria-label="Категории кейсов">
        {tabs.map((cat) => {
          const isActive = value === cat.id
          const icon = ICONS[cat.id] || null

          return (
            <button
              key={cat.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`cat-tab${isActive ? ' is-active' : ''}`}
              onClick={() => onChange(cat.id)}
            >
              {icon}
              <span className="cat-tab-label">{cat.label}</span>
              <span className="cat-tab-count">{cat.count}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}

